module.exports = __webpack_public_path__ + "static/customize_5-e3ffa47476777ad9417a72811b379806.png";